module.exports = __webpack_public_path__ + "media/landing_page/erdf-faf125e4.png";